<template>
    <div>

      <div class="container-fluid account-screen section">
          <account-information
            :carriers="carriers"
            :details="accountDetails"
            :mrc="calculateTotalMrc"
            @accountUpdate="accountUpdate"
          ></account-information>

          <ul class="nav" v-if="accountDetails.carrier_id">
            <li class="nav-item">
              <a class="nav-link" :class="{active: activeTab == 'cashflow'}" @click.prevent="activeTab = 'cashflow'" href="#">Cashflow</a>
            </li>

            <li class="nav-item">
              <a class="nav-link" :class="{active: activeTab == 'details'}" @click.prevent="activeTab = 'details'" href="#">Details</a>
            </li>
          </ul>
      </div>

      <div class="col-holder" v-show="activeTab == 'details'" v-if="accountDetails.carrier_id">
        <div class="row">
          <div class="col-12 col-xl-6">

            <account-products
               v-if="accountDetails.account_id"
              :carriers="carriers"
              :details="accountDetails"
              :carrierProducts="carrierProducts"
            ></account-products>

            <account-contacts
              :details="accountDetails"
              :accountContacts="accountContacts"
              @accountContactsUpdate="accountContactsUpdate"
              @accountContactsDelete="accountContactsDelete"
            >
            </account-contacts>

            <account-statement-matches

              :details="accountDetails"
              :accountStatementMatches="accountStatementMatches"
              @accountStatementMatchDelete="deleteAccountStatementMatch"
            >
            </account-statement-matches>

          </div>
          <div class="col-12 col-xl-6">
            <account-notes
              :account_id="$route.params.account_id"
              :details="accountDetails"
            >
            </account-notes>

            <account-agents
              :account_id="$route.params.account_id"
              :carrier_id="accountDetails.carrier_id"
            >
            </account-agents>

            <account-files
              :details="accountDetails"
            ></account-files>
          </div>

        </div>
      </div>


      <cashflow
        v-show="activeTab == 'cashflow'"
        :source_id="params.data.account_id"
        sourceFn="accountCashflow"
        label="Account"
        :name="accountDetails.name"
      ></cashflow>




    </div>

</template>
<script type="text/babel">
    import AccountInformation from './AccountInformation.vue';
    import AccountProducts from './AccountProducts.vue';
    import AccountFiles from './AccountFiles.vue';
    import AccountContacts from './AccountContacts.vue';
    import AccountNotes from './AccountNotes.vue';
    import AccountAgents from './AccountAgents.vue';
    import AccountStatementMatches from './AccountStatementMatches.vue';

    import DropdownConfirmation from '../assets/DropdownConfirmation.vue';
    import Cashflow from '../assets/Cashflow.vue';

    export default {
        data: function(){
            return {
              params: {
                function: 'accountDetails',
                data: {
                    account_id: ''
                }
              },
              accountDetails: {
                  name: '',
                  status_id: '',
                  carrier_id: '',
                  billing_startdate: '',
                  ink_date: '',
                  term: ''
              },
              activeTab: 'details',
              userRoles: [],
              carriers: [],
              carrierProducts:[],
              accountProducts:[],
              accountFiles:[],
              accountContacts:[],
              accountNotes:[],
              notepage: 0,
              accountAgents:[],
              accountStatementMatches:[],
              matchesPagination:{
                offset: 0,
                limit: 20
              }
            }
        },
        components:{
          AccountInformation,
          AccountProducts,
          AccountFiles,
          AccountContacts,
          AccountNotes,
          AccountAgents,
          AccountStatementMatches,
          DropdownConfirmation,
          Cashflow
        },
        created(){
          this.params.data.account_id = this.$route.params.account_id;
          this.fetchData();
          this.fetchCarriers();
        },
        computed:{
          calculateTotalMrc(){
            return this.accountProducts.reduce(function(a,b){
                return a += parseFloat(b.mrc);
            },0);
          },
          canApprove(){

            var canApprove = this.$store.getters.getUserRoles.filter(function(role){
              return role.name == "Accounts"
            }).map(function(role){
                return role.rolesPermissions.filter(function(rp){
                  return rp.rolePermission_id == 10
                }).map(function(rp){
                  return rp.state;
                })[0];
            })[0];

            return canApprove;

          }
        },
        methods:{
          fetchData(onlyData){

            this.$send(this, 'accountDetails',  this.params.data).then(r => {
              this.accountDetails = r.accountDetails;

              if(!onlyData){
                this.fetchCarrierProducts();
                this.fetchAccountContacts();
                this.fetchAccountStatementMatches();
              }
            });

          },
          fetchCarrierProducts(){

            this.$send(this, 'carrierProducts',  {
              carrier_id: this.accountDetails.carrier_id
            }).then(r => {
              console.log(r);
              this.carrierProducts = r.carrierProducts || [];
            });
          },
          approveAccount(status){
            this.accountUpdate({approved: status});
          },
          accountUpdate(data){

            data.account_id = this.params.data.account_id;

            this.$send(this, 'accountUpdate',  data).then(r => {
              this.fetchData(true);
            });

          },

          accountContactsUpdate(data){
            var _this = this;

            data.account_id = this.params.data.account_id;
            var fn = (data.accountContact_id)? 'accountContactsUpdate': 'accountContactsUpdate';

            this.$send(this, fn, data).then(r => {
                this.fetchAccountContacts();
            });

          },

          accountContactsDelete(data){
            var _this = this;
            data.account_id = this.params.data.account_id;

            this.$send(this, 'accountContactsDelete', data).then(r => {
              this.fetchAccountContacts()
            });
          },






          fetchAccountContacts(){

            this.$send(this, 'accountContacts',  this.params.data).then(r => {
              this.accountContacts = r.accountContacts || [];
            });

          },
          fetchAccountStatementMatches(){

            this.$send(this, 'accountStatementMatches',  {
              account_id: this.params.data.account_id,
              offset: this.matchesPagination.offset,
              limit: this.matchesPagination.limit
            }).then(r => {
              this.accountStatementMatches = r.accountStatementMatches;
            });
          },

          fetchAccountNotes(){


            this.$send(this, 'accountNotes',  {
              account_id: this.params.data.account_id,
            }).then(r => {
              this.accountNotes = r.accountNotes;
              this.notepage = r.count;
            });
          },

          deleteAccountStatementMatch(m){


            this.$send(this, 'accountStatementMatchDelete',  {
              accountStatementMatch_id: m.accountStatementMatch_id
            }).then(r => {
              this.fetchAccountStatementMatches();
            });

          },

          fetchCarriers(){

            this.$send(this, 'carriers').then(r => {
              this.carriers = r.carriers;
            });
          }
        }
    }

</script>
<style>
  .fade-enter-active, .fade-leave-active {
    transition: opacity .5s
  }
  .fade-enter, .fade-leave-to /* .fade-leave-active in <2.1.8 */ {
    opacity: 0
  }
  .container-fluid.col-holder{
    background: none;
    box-shadow: none;
    padding: 0;
  }
  .account-screen .nav{
  }
  .account-screen .nav{
    border-top: 1px solid #e2e2e2;
  }


  .account-screen a.nav-link {
    padding: 10px 20px;
    background: #e3eaf1;
    margin: 10px 5px 0;
    -webkit-border-radius:4px;
    -moz-border-radius:4px;
    border-radius:4px;
    font-weight: 700;
  }

  .account-screen a.nav-link.active {
    background:#325482;
    color: white;
  }

</style>



// WEBPACK FOOTER //
// AccountDetails.vue?d4955a0e